/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 18:01:23
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 18:30:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/Denomination/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import { useSelector, useDispatch } from 'react-redux';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Select } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import DeleteInput from 'src/components/DeleteInput';
import SectionHOC from '../HOC';
import {
  EnumCollapseId,
  onProductDenominationsCurrencyChange,
  onProductDenominationsDenominationsChange,
  getDenomination,
} from '../slice';
import { StyledTitle } from 'src/layout/EditorPageLayout/SectionTitle';
import { ActionType } from 'src/types/common/common';
import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';
//import Add from 'src/components/GreenAddBtn/GreenAddBtn';
import { getCurrencies } from '@/src/constrains/GlobalProvider/slice';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Denomination = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  const currencies = useSelector(getCurrencies());
  const currenciesList = (currencies || []).map((i) => {
    const { code } = i;
    return { label: code, value: code };
  });
  const _d = useDispatch();
  const data = useSelector(getDenomination()) || {};
  const { currency, denominations = [] } = data;
  const handleOnCurrencyChange = (currency) => {
    _d(onProductDenominationsCurrencyChange(currency));
  };
  const handleOnDenominationsChange = ({ index, value }) => {
    _d(
      onProductDenominationsDenominationsChange({
        value,
        index,
        type: ActionType.modify,
      }),
    );
  };
  // const handleOnDenominationsAdd = () => {
  //   _d(
  //     onProductDenominationsDenominationsChange({
  //       type: ActionType.add,
  //     }),
  //   );
  // };
  const handleOnDenominationsDelete = (index) => {
    _d(
      onProductDenominationsDenominationsChange({
        index,
        type: ActionType.delete,
      }),
    );
  };

  const denominationMap = denominations.reduce((pre, now, index) => {
    if (pre[now]) {
      pre[now].push(index);
    } else {
      pre[now] = [index];
    }
    return pre;
  }, {});

  const checkDuplicatedDenominations = Object.keys(denominationMap).reduce(
    (pre, now) => {
      if (denominationMap[now] && denominationMap[now].length > 1) {
        const _temp = [...(denominationMap[now] || [])];
        _temp.shift();
        pre.push(..._temp);
      }
      return pre;
    },
    [],
  );
  const { label } = currenciesList.find((i) => i.value === currency) || {};
  const generateDenominations = () => {
    const _noDelete = denominations.length === 1;
    return denominations.map((i, index) => {
      const hasError = checkDuplicatedDenominations.includes(index);

      return (
        <div className={css.inputContainer} key={index}>
          <DeleteInput
            disabled={disabled}
            inputProps={{
              suffix: label || '',
              mode: EnumMode.money,
              error: hasError,
              help: getI18n(
                'allProducts.addvirtualproduct.denomination_general_help',
              ),
            }}
            value={i}
            {...(_noDelete
              ? {}
              : {
                  onDelete: handleOnDenominationsDelete.bind(this, index),
                })}
            onChange={(value) => {
              handleOnDenominationsChange({
                value: value == null || value === '' ? 0 : value,
                index,
              });
            }}
          />
        </div>
      );
    });
  };

  return (
    <div className={css.container}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n('general.currency')}
                bottomTitle={getI18n(
                  'allProducts.addvirtualproduct.denomination_general_currency_bottomTitle',
                )}>
                <Select
                  disabled={disabled}
                  size='large'
                  selectClassName={css.select}
                  onChange={handleOnCurrencyChange}
                  value={currency}
                  optionsList={currenciesList}
                />
              </ItemWrapper>
            ),
          },
          {
            child: <React.Fragment />,
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'allProducts.addvirtualproduct.denomination_general_denominations',
                )}>
                {generateDenominations()}
                {/* <Add
                  addText='+ Add denomination'
                  addFun={handleOnDenominationsAdd}
                /> */}
              </ItemWrapper>
            ),
          },
          {
            child: <React.Fragment />,
          },
        ]}
      />
    </div>
  );
};
export default SectionHOC(Denomination, {
  useDefaultCollapseContent: true,
  useCustomCollapseTitle: true,
  title: (
    <StyledTitle
      left={`${getI18nFromGeneral('general.hOCTitle.denominations')}*`}
      leftBottom={getI18nFromGeneral('general.hOCTitle.denominationsBottom')}
    />
  ),
  id: EnumCollapseId.Denomination,
});
